/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "../components/SmoothScroll";
import { Helmet } from "react-helmet-async";
const Accessibility = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
    <>
      <Helmet>
        <title> Accessibility Statement | Citrus Diagnostic Center</title>
        <meta
          name="description"
          content="This accessibility statement outlines website accessibility standards, digital inclusivity efforts, and support options for users with disabilities."
        />
        <meta
          name="keywords"
          content="accessibility statement
website accessibility

"
        />
      </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-48 ">
        <div className="lg:w-[90%] w-[95%] mx-auto  flex flex-col items-center  pb-8 lg:pb-16">
          <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  px-4 mb-4 text-center capitalize w-full">
            {" "}
            Accessibility Statement
          </h1>
          <div className="text-left mt-10">
            <h2 className="lg:text-[32px] text-left  text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize">
              {" "}
              Citrus Diagnostic Center
            </h2>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pt-4 text-left  font-robout">
              Citrus Diagnostic Center is committed to providing a website that
              is accessible to all users, including individuals with
              disabilities.
            </p>
            <p className="text-[17px] text-[#ccc]  lg:ps-0 md:px-8 px-4 pt-2 text-left  font-robout">
              We strive to ensure that our website content is accessible and
              usable, and we make ongoing efforts to improve accessibility and
              usability in accordance with applicable standards.
            </p>
            <p className="text-[17px] text-[#ccc]  lg:ps-0 md:px-8 px-4 pt-2 text-left  font-robout">
              If you experience difficulty accessing any part of this website,
              or if you need assistance with scheduling, information, or
              services, we encourage you to contact us directly. Our team is
              available to assist you.
            </p>
            <p className="text-[17px] text-[#ccc]  lg:ps-0 md:px-8 px-4 pt-2 text-left font-robout">
              We welcome feedback regarding website accessibility and will
              consider reasonable requests for accommodation.
            </p>

            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Contact Us for Accessibility Assistance:
            </h2>
            <ul className="xl:text-[1.33rem]  md:text-lg text-lg flex flex-col gap-3 text-[#ccc] lg:ps-0 md:px-8 px-4 pb-8  text-left font-robout">
              <li>
                <span className="text-[#ccc] font-normal">Phone : </span>{" "}
                <a href="tel:352-795-9200" className="hover:underline">
                  {" "}
                  352-795-9200
                </a>
              </li>
              <li>
                <span className="text-[#ccc] font-normal">Fax : </span>{" "}
                <a href="tel:352-795-6460" className="hover:underline">
                  {" "}
                  352-795-6460
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Accessibility;
